<div class="container-fluid" *ngIf="_prjctService.formHideShow==0">
    <!-- <div class="row flex-body">
        <div class="col-md-11 col-md-offset-1">
            <div class="box">
                <h4 class="box-title">Project</h4>
            </div>

            <div class="col-md-4 offset-md-8 searchBox">
                <div class="form-group row no-gutters">
                    <div class="col-12 col-sm-6 col-md-2"><button type="button" class="btn-sm btn-info"
                            (click)="addList()"><i class="fas fa-plus" aria-hidden="true"></i></button></div>
                    <div class="col-12 col-sm-6 col-md-8"><input type="text" class="form-control-search" name="search"
                            [(ngModel)]="term"></div>
                    <div class="col-6 col-md-2"><button class="btn-info"><i class="fas fa-search"
                                aria-hidden="true"></i></button></div>
                </div>
            </div> -->
    <div id="form-wrap">
        <h2 class="heading_all">PROJECT</h2>
        <br>
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4"></div>
            <div class="col-md-4 ">

                <table>
                    <thead>
                        <tr>
                            <td>
                                <button type="button" class="btn-sm btn-info" (click)="addList()"><i class="fas fa-plus"
                                        aria-hidden="true"></i></button>
                            </td>
                            <td style="width: 70%;"><input type="text" class="form-control-search" name="search"
                                    [(ngModel)]="term"></td>
                            <td><button class="btn-info"><i class="fas fa-search" aria-hidden="true"></i></button></td>
                        </tr>
                    </thead>
                </table>

            </div>
        </div>

        <table>
            <thead>
                <tr>
                    <th>#</th>
                    <!-- <th (click)="sort('code')"> Code</th>
                        <th (click)="sort('name')">Name</th>
                        <th>Action</th> -->
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('Code')">
                            <span *ngIf="!_prjctService.isFiltering">Code</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_prjctService.orderByColName!='Code' "></i>
                                <div *ngIf="_prjctService.orderByColName=='Code'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_prjctService.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_prjctService.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_prjctService.isFiltering">
                            <input type="text" #txtCodeFilter="ngModel" [(ngModel)]="_prjctService.CodeFilter"
                                placeholder="CodeName">
                        </div>

                    </th>
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('Name')">
                            <span *ngIf="!_prjctService.isFiltering">Name</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_prjctService.orderByColName!='Name' "></i>
                                <div *ngIf="_prjctService.orderByColName=='Name'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_prjctService.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_prjctService.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_prjctService.isFiltering">
                            <input type="text" #txtNameFilter="ngModel" [(ngModel)]="_prjctService.NameFilter"
                                placeholder="Name">
                        </div>

                    </th>
                    <th><em></em> Settings
                        <a class="AtjIsPoint AtjfloatRight" (click)="toggleFilter()">
                            <i *ngIf="!_prjctService.isFiltering" class="fas fa-filter"></i>
                            <i *ngIf="_prjctService.isFiltering" class="fas fa-times"></i>
                        </a>
                    </th>
                </tr>
            </thead>
            <tbody>
                <!-- <tr *ngFor="let prjct of _prjctService.allProjects | orderBy: key : reverse | filter:term | paginate: { itemsPerPage: NoOfItems, currentPage: p }; let i = index"
                        class="ng-scope"> -->
                <tr *ngFor="let prjct of _prjctService.allProjects | gridOperations  :_prjctService.pageIndex: 
                        {Code:_prjctService.CodeFilter,Name:_prjctService.NameFilter}:
                       {Column:_prjctService.orderByColName,Dir:_prjctService.orderByDir} ; let i = index"
                    class="ng-scope">
                    <td>{{i+1+((NoOfItems*_prjctService.pageIndex)-NoOfItems)}}</td>
                    <td>{{prjct.Code}}</td>
                    <td>{{prjct.Name}}</td>
                    <td>
                        <button type="button" class="btn-success" (click)="showForEdit(prjct)">
                            <i class="fas fa-pen-square" aria-hidden="true"></i></button>

                        <button type="button" class="btn-danger" (click)="onDelete(prjct.Id)"><i class="fas fa-trash"
                                aria-hidden="true"></i></button>
                    </td>
                </tr><!-- end ngRepeat: item in items -->
                <tr>
                    <td colspan="5"
                        *ngIf="(_prjctService.allProjects?.length<=0 )  || _CommonService.filterdItemCount<1">
                        No Records To
                        Display.</td>
                </tr>
            </tbody>
            <tfoot>
                <td colspan="4" *ngIf="_CommonService.totalPageCount>1">
                    <app-grid-pagination (pageIndexValue)="_prjctService.pageIndex=$event">
                    </app-grid-pagination>
                </td>
            </tfoot>
        </table>
        <!-- <pagination-controls (pageChange)="p = $event"></pagination-controls> -->
        <div class="margintop"></div>
        <!-- </div>
    </div> -->
    </div>
</div>
<!-- <app-confirmation-dialog *ngIf="popVisible" (ConfirmEvent)="dialogResult($event)" [title]="'Project'">
</app-confirmation-dialog> -->



<app-delete-confirm *ngIf="popVisible" [title]="'PROJECT'" (ConfirmEvent)="dialogResult($event)"></app-delete-confirm>